<div class="sponsoring__overlay" (click)="onClose()"></div>
<div class="sponsoring__content"
     [@openClose]="openAnimationState"
     [ngClass]="{ 'sponsoring__content-desktop': !isMobile }"
     [style.width]="!!width ? width : null"
>
  <div class="close__wrapper">
    <button type="button" class="close__wrapper-button" (click)="onClose()">
      <mm-icon class="close__wrapper-icon" name="close"></mm-icon>
    </button>
  </div>
  <div class="vas" [style.height]="'100%'">
    <ng-content></ng-content>
  </div>
</div>
